import React from 'react';
import moment from "moment";
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import userCategory from '../../constants/userCategory.js';
import userTypeConsts from '../../constants/userTypeConsts';
import { setDashboardDate, setInvoiceType } from "../../features/invoice/invoiceSlice";
import { resetAccountDetails } from "../../features/accountDetails/accountDetailsSlice.js";
import { setSideBarText } from '../../features/sideBarText/sideBarTextSlice.js';
import { ReactComponent as DashboardNavIcon } from '../../images/icons/dashboardIcon.svg';
import { ReactComponent as UsersNavIcon } from '../../images/icons/usersIcon.svg';
import { ReactComponent as InvoicesNavIcon } from '../../images/icons/invoicesIcon.svg';
import { ReactComponent as TimeTrackerNavIcon } from '../../images/icons/timeTrackerIcon.svg';
import './MobilePageTitle.css';

const MobilePage = () => {
    const dispatch = useDispatch();
    const headerText = useSelector((state) => state.headerText.headerTextState);
    const user = useSelector((state) => state.auth.user);
    const { appSettings } = useSelector((state) => state.appSettings);
    const isMvp = process.env.REACT_APP_ENV_TYPE === 'mvp';

    const handleTabClick = () => {
        dispatch(resetAccountDetails());
        dispatch(setSideBarText(""));
        dispatch(setInvoiceType(null));
        dispatch(setDashboardDate([
            new Date(moment().tz(global.config?.getTimeZone?.() || 'UTC').subtract(30, 'years').startOf('year').format()).toISOString(),
            new Date(moment().tz(global.config?.getTimeZone?.() || 'UTC').endOf('year').format()).toISOString()
        ]));
    };

    const isClient = user?.userCategory === userCategory.Client;
    const isVendor = user?.userCategory === userCategory.Vendor;
    const isAdmin = user?.userType === userTypeConsts.SUPER_ADMIN || user?.userType === userTypeConsts.ADMIN;
    const isProjectManager = user?.userType === userTypeConsts.PROJECT_MANAGER;

    return (
        <div className="mobile-nav-pills-container">
            <div className="mobile-nav-pills-scroll">
                {/* Dashboard */}
                <Link
                    to={isVendor ? "/vendor/dashboard" : isClient ? "/client/dashboard" : "/user/dashboard"}
                    className={`mobile-nav-pill ${headerText === "Dashboard" ? "active" : ""}`}
                    onClick={handleTabClick}
                >
                    <span className="mobile-pill-icon">
                        <DashboardNavIcon width="15.11" height="15.11" />
                    </span>
                    <span>{global.config.locate(appSettings && appSettings.language, 'Dashboard')}</span>
                </Link>

                {/* Users / My Team (Admins only) */}
                {isAdmin && !isVendor && !isClient && (
                    <Link
                        to="/user/myteam/list"
                        className={`mobile-nav-pill ${headerText === "My Team" ? "active" : ""}`}
                        onClick={handleTabClick}
                    >
                        <span className="mobile-pill-icon">
                            <UsersNavIcon width="17.16" height="14.18" />
                        </span>
                        <span>Users</span>
                    </Link>
                )}

                {/* Invoices */}
                <Link
                    to={isVendor ? "/vendor/invoice" : isClient ? "/client/invoice" : "/user/invoices"}
                    className={`mobile-nav-pill ${headerText === "Invoices" ? "active" : ""}`}
                    onClick={handleTabClick}
                >
                    <span className="mobile-pill-icon">
                        <InvoicesNavIcon width="13" height="17" />
                    </span>
                    <span>{global.config.locate(appSettings && appSettings.language, 'Invoices')}</span>
                </Link>

                {/* Time Tracker */}
                {(user && (user.userCategory === userCategory.Individual || user.userCategory === userCategory.Business)) && (
                    <Link
                        to="/user/time-tracker/overview"
                        className={`mobile-nav-pill ${headerText === "Time Tracker" ? "active" : ""}`}
                        onClick={handleTabClick}
                    >
                        <span className="mobile-pill-icon">
                            <TimeTrackerNavIcon width="15" height="17" />
                        </span>
                        <span>{global.config.locate(appSettings && appSettings.language, 'Time_Tracker')}</span>
                    </Link>
                )}

                {/* Time Off */}
                {!isMvp && (!isVendor && !isClient) && (
                    <Link
                        to="/user/time-off/overview"
                        className={`mobile-nav-pill ${(headerText === "Time Off" || headerText === "Time Off Settings") ? "active" : ""}`}
                        onClick={handleTabClick}
                    >
                        <span className="mobile-pill-icon">
                            <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="2" y="4" width="16" height="14" rx="2.5" stroke="currentColor" strokeWidth="1.8" />
                                <path d="M2 8.5H18" stroke="currentColor" strokeWidth="1.8" />
                                <path d="M6 2V5M14 2V5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                            </svg>
                        </span>
                        <span>{global.config.locate(appSettings && appSettings.language, 'Time_Off')}</span>
                    </Link>
                )}

                {/* Expenses */}
                {!isMvp && (isAdmin || isProjectManager) && (
                    <Link
                        to="/user/expense/overview"
                        className={`mobile-nav-pill ${headerText === "Expenses" ? "active" : ""}`}
                        onClick={handleTabClick}
                    >
                        <span className="mobile-pill-icon">
                            <svg width="19" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="1.5" y="1.5" width="17" height="13" rx="2" stroke="currentColor" strokeWidth="1.8" />
                                <path d="M1.5 5.5H18.5" stroke="currentColor" strokeWidth="1.8" />
                                <rect x="4.5" y="9.5" width="3" height="2" rx="0.5" fill="currentColor" />
                            </svg>
                        </span>
                        <span>{global.config.locate(appSettings && appSettings.language, 'Expenses')}</span>
                    </Link>
                )}
            </div>
        </div>
    );
};

export default MobilePage;